<template>
  <vx-card :title='$t("Passkeys")'>
    <vs-button type="border" color="warning" @click="addPasskeyPrompt = true" class="mb-4">{{ $t("Add") }}</vs-button>
    <vs-table :data="userPasskeys">
      <template slot="thead">
        <vs-th>{{ $t("Name") }}</vs-th>
        <vs-th></vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].identifier">
            {{ data[indextr].identifier }}
          </vs-td>

          <vs-td>
            <vs-button style="float:left;" type="border" color="danger" icon-pack="feather" icon="icon-trash-2"
                       @click="removePasskey(data[indextr].id)"></vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <vs-popup :title="$t('Add')" :active.sync="addPasskeyPrompt">
      <div>
        <p class="mt-6">{{ $t("Name") }}</p>
        <vs-input v-model="addName" style="width: 100%"></vs-input>
        <vs-divider/>
        <vs-button color="success" type="border" class="mt-6; mr-1" @click="addPasskey">{{ $t("Add") }}</vs-button>
      </div>
    </vs-popup>
  </vx-card>
</template>
<script>

// eslint-disable-next-line no-undef
const { startRegistration } = SimpleWebAuthnBrowser;

export default {
  data() {
    return {
      userPasskeys: [],

      addPasskeyPrompt: false,

      addName: '',
    }
  },
  methods: {
    updatePasskeys() {
      const thisIns = this;
      this.$http.get('/api/v1/profile/passkeys')
          .then(function (response) {
            thisIns.userPasskeys = response.data;
          })
          .catch(function (error) {
            thisIns.$vs.notify({
              title: 'Error',
              text: error,
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            })
          });
    },
    async addPasskey() {

      try {

        const creationRequestResponse = await this.$http.get('/api/v1/profile/passkeys/add/start')

        const createResponse = await startRegistration({
          optionsJSON: creationRequestResponse.data.creation.publicKey
        })

        if (!createResponse) throw new Error("invalid response")

        await this.$http.post('/api/v1/profile/passkeys/add/finalize', {
          token: creationRequestResponse.data.creation_token,
          creation_response: createResponse,
          identifier: this.addName
        })

        this.updatePasskeys();
        this.addPasskeyPrompt = false;
        this.addName = "";

      }catch(error) {
        this.addPasskeyPrompt = false;
        this.$vs.notify({
          title: 'Error',
          text: error,
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      }
    },
    removePasskey(id) {
      const thisIns = this;
      this.$http.delete('/api/v1/profile/passkeys/' + id).then(function () {
        thisIns.updatePasskeys();
      }).catch(function (error) {
        thisIns.$vs.notify({
          title: 'Error',
          text: error.response.data,
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      });
    }
  },
  watch: {
    addPasskeyPrompt: function () {
      if (!this.addPasskeyPrompt) {
        this.addName = ""
      }
    }
  },
  created() {
    this.updatePasskeys()
  },
  beforeRouteLeave(to, from, next) {
    if (this.addPasskeyPrompt) {
      this.addPasskeyPrompt = false;
      next(false)
    } else {
      next()
    }
  }
}
</script>
